module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Trend")]), _vm._v(" "), _c('table', [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.orderedCategories), function(category) {
    return _c('tr', {
      key: category
    }, [_c('td', [_c('div', {
      staticClass: "flexRow category-label"
    }, [_vm._v("\n            " + _vm._s(_vm.categories[category].name) + "\n            "), _c('static-block-row', {
      attrs: {
        "color": _vm.categories[category].color,
        "completed": 1,
        "quota": 1,
        "size": "small"
      }
    })], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Math.round(_vm.getAverageDailyQuota(category) * 10) / 10))]), _vm._v(" "), _vm._l((_vm.getCategoryAverages(category)), function(average, i) {
      return _c('td', {
        key: ("" + i + category),
        style: (("background-color: " + (_vm.getBackgroundStyle(category, average))))
      }, [_vm._v("\n          " + _vm._s(Math.round(average.average * 10) / 10) + "\n          "), (average.range === 1) ? _c('i', {
        staticClass: "material-icons quota-status",
        class: _vm.quotaStatusIcon(category, average)
      }, [_vm._v(_vm._s(_vm.quotaStatusIcon(category, average)))]) : _c('div', {
        staticClass: "impact-today"
      }, [_c('i', {
        staticClass: "material-icons impact-icon",
        class: _vm.impactStatusIcon(_vm.getDayImpact(category, average))
      }, [_vm._v("\n              " + _vm._s(_vm.impactStatusIcon(_vm.getDayImpact(category, average))) + "\n            ")]), _vm._v("\n            " + _vm._s(_vm.getDayImpact(category, average)) + "\n          ")])])
    })], 2)
  }), 0)]), _vm._v(" "), _c('div')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "right",
      "padding-right": "3rem"
    }
  }, [_vm._v("Category")]), _vm._v(" "), _c('th', [_vm._v("Quota")]), _vm._v(" "), _c('th', [_vm._v("90")]), _vm._v(" "), _c('th', [_vm._v("60")]), _vm._v(" "), _c('th', [_vm._v("30")]), _vm._v(" "), _c('th', [_vm._v("7")]), _vm._v(" "), _c('th', [_vm._v("Today")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b7083e30!./~/vue-loader/lib/selector.js?type=template&index=0!./dev/src/views/TrendView.vue
// module id = ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-b7083e30!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./dev/src/views/TrendView.vue
// module chunks = 0